export enum ModuleEnum {
    air = 'air',
    water = 'water',
    waterByValve = 'waterByValve',
    sensor = 'sensor',
    findByDesign = 'findByDesign',
    WaterSolution = 'WaterSolution',
    vau = 'vau',
    AirSolution = 'AirSolution',
    SensorSolution = 'SensorSolution',
    ValveSolution = 'ValveSolution',
    ValveSizer = 'ValveSizer',
    ActuatorSizer = 'ActuatorSizer',
    SensorSizer = 'SensorSizer',
    Accessory = 'Accessory',
    FireAndSmoke = 'FireAndSmoke',
    FireAndSmokeSolution = 'FireAndSmokeSolution',
}
